import { defineComponent } from "vue";
import Arrow from "./component-library4.mjs";
import Dismissable from "./component-library232.mjs";
import LinkButton from "./component-library3.mjs";
const _sfc_main = defineComponent({
  name: "EnergyLabelDatasheet",
  components: { LinkButton, Arrow },
  mixins: [Dismissable],
  props: {
    label: { type: String, default: "Produktdatenblatt" },
    labelColor: { type: String, default: "" },
    products: {
      type: Array,
      required: true
    },
    alignDropdown: {
      type: String,
      default: "right",
      validator(value) {
        return ["right", "left", "justify"].includes(value);
      }
    },
    isInternalLink: { type: Boolean }
  },
  emits: ["open-document"],
  computed: {
    filteredList() {
      return this.products.filter((product) => !!product.documentPath);
    },
    singleItem() {
      return this.filteredList.length === 1 ? this.filteredList[0] : void 0;
    }
  },
  watch: {
    opened(isOpened) {
      this.isOpened = isOpened;
    }
  },
  methods: {
    openNewTab(entry) {
      window.open(entry, "_blank");
    },
    onEsc() {
      if (this.isClosed)
        return;
      this.close();
    },
    onToggle() {
      this.toggle();
    }
  }
});
export {
  _sfc_main as default
};
